import { SagaIterator } from 'redux-saga';
import { put, call, takeLatest, StrictEffect } from 'redux-saga/effects';
import {
  fetchSiteUsers,
  fetchSiteUsersError,
  fetchSiteUsersSearch,
  fetchSiteUsersSuccess,
  putSiteUsersStatus,
} from './index';
import { apiInstance } from 'src/services/interceptor';
import { PayloadAction } from '@reduxjs/toolkit';

function* getSiteUsers(): SagaIterator {
  try {
    const response = yield call(apiInstance, `/admin/tenants`);
    yield put(fetchSiteUsersSuccess(response.data));
  } catch (e) {
    yield put(fetchSiteUsersError());
  }
}

interface PutIssuesPayloadProps {
  siteId: string;
  issueId: string;
  data: {
    status: string;
  };
  tenantId: string;
  params: {
    search: string;
    active: string;
    paymentPlan: string;
    userType: string;
  };
}

function* putSiteUsersStatusSaga({ payload }: PayloadAction<PutIssuesPayloadProps>): SagaIterator {
  try {
    // console.log(payload);
    yield call(apiInstance.put, `admin/tenants/${payload.tenantId}`, payload.data);
    yield put(fetchSiteUsers());
  } catch (e) {
    yield put(fetchSiteUsersError());
  }
}

function* getSiteUsersSearch({ payload: { params } }: PayloadAction<PutIssuesPayloadProps>): SagaIterator {
  try {
    const response = yield call(apiInstance, `/admin/tenants`, {
      params: params ?? {},
    });
    yield put(fetchSiteUsersSuccess(response.data));
  } catch (e) {
    yield put(fetchSiteUsersError());
  }
}
function* siteUsersSaga(): Generator<StrictEffect, void> {
  yield takeLatest(fetchSiteUsers.type, getSiteUsers);
  yield takeLatest(putSiteUsersStatus.type, putSiteUsersStatusSaga);
  yield takeLatest(fetchSiteUsersSearch.type, getSiteUsersSearch);
}

export { siteUsersSaga };
